// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"81":"cc596248","237":"a4284a7d","257":"f3123bad","588":"aa8175ba","872":"cc596248"}[chunkId] + ".css";
};